import { Breadcrumbs } from '@synergy-marine-group/synergy-ui';
import React from 'react';

const BreadCrumNavigation = ({ currentPage, parentPage, parentPageLink }) => {
  return (
    <Breadcrumbs
      className=""
      items={[
        {
          isActive: false,
          label: parentPage,
          isClickable: true,
          url: parentPageLink,
          orderId: 1
        },
        {
          isActive: true,
          label: currentPage,
          orderId: 2
        }
      ]}
    />
  );
};

export default BreadCrumNavigation;
